export default ({ faviconUrl }) => ({
  faviconUrl
})
